module.exports = __webpack_public_path__ + "media/Werbung_LG.fbd24eda.mp3";